"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sum = exports.Predicates = void 0;
var data_1 = require("./data");
var never = function (_) { return false; };
var is = function (_) { return _ !== null && _ !== undefined; };
var isString = function (_) { return typeof _ === 'string'; };
var isBoolean = function (_) { return typeof _ === 'boolean'; };
var isNumber = function (_) { return typeof _ === 'number'; };
var isFunction = function (_) { return typeof _ === 'function'; };
var isPrimitive = function (_) { return typeof _ !== 'object'; };
var isArray = Array.isArray;
var isArrayOf = function (pred) { return function (_) {
    if (!Array.isArray(_)) {
        return false;
    }
    for (var _i = 0, _a = _; _i < _a.length; _i++) {
        var x = _a[_i];
        if (!pred(x)) {
            return false;
        }
    }
    return true;
}; };
var isObject = function (_) { return typeof _ === 'object' && _ !== null; };
var isRecordOf = function (predicateMap) {
    var keys = Object.keys(predicateMap);
    var predicates = keys.map(function (key) { return predicateMap[key]; });
    var length = keys.length;
    return function (_) {
        if (!_) {
            return false;
        }
        for (var i = 0; i < length; i++) {
            if (!predicates[i](_[keys[i]])) {
                return false;
            }
        }
        return true;
    };
};
exports.Predicates = {
    never: never, is: is, isString: isString, isBoolean: isBoolean, isNumber: isNumber, isFunction: isFunction,
    isPrimitive: isPrimitive, isArray: isArray, isArrayOf: isArrayOf, isObject: isObject, isRecordOf: isRecordOf
};
exports.Sum = function (input) {
    var typeOf;
    var parseTypeOf;
    var unroll = false;
    var keys;
    var predicates = [];
    var one = never, two = never, three = never, four = never, five = never;
    var six = never, seven = never, eight = never, nine = never, ten = never;
    var group;
    function unmatched(value) {
        var name = keys ? "[" + keys.join(', ') + "]" : 'typeOf Sum';
        throw new TypeError("Unmatched against: " + name + ", value: " + JSON.stringify(value, null, 2));
    }
    if (isFunction(input.typeOf)) {
        parseTypeOf = input.typeOf;
        typeOf = function (a) {
            var t = parseTypeOf(a);
            return t ? t : unmatched(a);
        };
        group = function (as) {
            var keyed = {};
            for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
                var a = as_1[_i];
                var typ = typeOf(a);
                var atKey = keyed[typ];
                if (atKey) {
                    atKey.push(a);
                }
                else {
                    keyed[typ] = [a];
                }
            }
            return keyed;
        };
    }
    else {
        var predicatesInput = input.predicates;
        var predicateMap_1;
        if (exports.Predicates.isFunction(predicatesInput)) {
            predicateMap_1 = predicatesInput(exports.Predicates);
        }
        else {
            predicateMap_1 = predicatesInput;
        }
        keys = Object.keys(predicateMap_1);
        predicates = keys.map(function (key) { return predicateMap_1[key]; });
        var cases_1 = keys.length;
        unroll = cases_1 <= 10;
        var onek_1 = keys[0], twok_1 = keys[1], threek_1 = keys[2], fourk_1 = keys[3], fivek_1 = keys[4], sixk_1 = keys[5], sevenk_1 = keys[6], eightk_1 = keys[7], ninek_1 = keys[8], tenk_1 = keys[9];
        one = predicates[0], two = predicates[1], three = predicates[2], four = predicates[3], five = predicates[4], six = predicates[5], seven = predicates[6], eight = predicates[7], nine = predicates[8], ten = predicates[9];
        switch (cases_1) {
            case 1:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    return undefined;
                };
                break;
            case 2:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    return undefined;
                };
                break;
            case 3:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    return undefined;
                };
                break;
            case 4:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    return undefined;
                };
                break;
            case 5:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    return undefined;
                };
                break;
            case 6:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    if (six(input)) {
                        return sixk_1;
                    }
                    return undefined;
                };
                break;
            case 7:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    if (six(input)) {
                        return sixk_1;
                    }
                    if (seven(input)) {
                        return sevenk_1;
                    }
                    return undefined;
                };
                break;
            case 8:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    if (six(input)) {
                        return sixk_1;
                    }
                    if (seven(input)) {
                        return sevenk_1;
                    }
                    if (eight(input)) {
                        return eightk_1;
                    }
                    return undefined;
                };
                break;
            case 9:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    if (six(input)) {
                        return sixk_1;
                    }
                    if (seven(input)) {
                        return sevenk_1;
                    }
                    if (eight(input)) {
                        return eightk_1;
                    }
                    if (nine(input)) {
                        return ninek_1;
                    }
                    return undefined;
                };
                break;
            default:
                parseTypeOf = function (input) {
                    if (one(input)) {
                        return onek_1;
                    }
                    if (two(input)) {
                        return twok_1;
                    }
                    if (three(input)) {
                        return threek_1;
                    }
                    if (four(input)) {
                        return fourk_1;
                    }
                    if (five(input)) {
                        return fivek_1;
                    }
                    if (six(input)) {
                        return sixk_1;
                    }
                    if (seven(input)) {
                        return sevenk_1;
                    }
                    if (eight(input)) {
                        return eightk_1;
                    }
                    if (nine(input)) {
                        return ninek_1;
                    }
                    if (ten(input)) {
                        return tenk_1;
                    }
                    for (var i = 10; i < cases_1; i++) {
                        if (predicates[i](input)) {
                            return keys[i];
                        }
                    }
                    return undefined;
                };
                break;
        }
        typeOf = function (a) {
            var t = parseTypeOf(a);
            return t ? t : unmatched(a);
        };
        group = function (as) {
            var keyed = {};
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                keyed[key] = [];
            }
            for (var _a = 0, as_2 = as; _a < as_2.length; _a++) {
                var a = as_2[_a];
                keyed[typeOf(a)].push(a);
            }
            return keyed;
        };
    }
    var functions = {
        types: undefined,
        names: undefined,
        typeOf: typeOf,
        is: function (typename, _) {
            return arguments.length === 2 ? typeOf(_) === typename : function (_) { return typeOf(_) === typename; };
        },
        equals: function (a, b) {
            var ta = typeOf(a);
            return ta && ta === typeOf(b) && data_1.Data.equals(a, b);
        },
        parse: function (a) {
            var type = parseTypeOf(a);
            return type ? a : undefined;
        },
        group: group,
        match: function (a, p) {
            return p[typeOf(a)](a);
        },
        f: function (p) {
            var match1;
            if (unroll) {
                var _a = keys.map(function (k) { return p[k]; }), _b = _a[0], onef_1 = _b === void 0 ? unmatched : _b, _c = _a[1], twof_1 = _c === void 0 ? unmatched : _c, _d = _a[2], threef_1 = _d === void 0 ? unmatched : _d, _e = _a[3], fourf_1 = _e === void 0 ? unmatched : _e, _f = _a[4], fivef_1 = _f === void 0 ? unmatched : _f, _g = _a[5], sixf_1 = _g === void 0 ? unmatched : _g, _h = _a[6], sevenf_1 = _h === void 0 ? unmatched : _h, _j = _a[7], eightf_1 = _j === void 0 ? unmatched : _j, _k = _a[8], ninef_1 = _k === void 0 ? unmatched : _k, _l = _a[9], tenf_1 = _l === void 0 ? unmatched : _l;
                match1 = function (a) {
                    if (one(a)) {
                        return onef_1(a);
                    }
                    if (two(a)) {
                        return twof_1(a);
                    }
                    if (three(a)) {
                        return threef_1(a);
                    }
                    if (four(a)) {
                        return fourf_1(a);
                    }
                    if (five(a)) {
                        return fivef_1(a);
                    }
                    if (six(a)) {
                        return sixf_1(a);
                    }
                    if (seven(a)) {
                        return sevenf_1(a);
                    }
                    if (eight(a)) {
                        return eightf_1(a);
                    }
                    if (nine(a)) {
                        return ninef_1(a);
                    }
                    if (ten(a)) {
                        return tenf_1(a);
                    }
                    unmatched(a);
                };
            }
            else {
                match1 = function (a) { return p[typeOf(a)](a); };
            }
            return spreadInto(match1, p);
        },
        f2: function (p) {
            var match2;
            if (unroll) {
                var _a = keys.map(function (k) { return p[k]; }), _b = _a[0], onef_2 = _b === void 0 ? unmatched : _b, _c = _a[1], twof_2 = _c === void 0 ? unmatched : _c, _d = _a[2], threef_2 = _d === void 0 ? unmatched : _d, _e = _a[3], fourf_2 = _e === void 0 ? unmatched : _e, _f = _a[4], fivef_2 = _f === void 0 ? unmatched : _f, _g = _a[5], sixf_2 = _g === void 0 ? unmatched : _g, _h = _a[6], sevenf_2 = _h === void 0 ? unmatched : _h, _j = _a[7], eightf_2 = _j === void 0 ? unmatched : _j, _k = _a[8], ninef_2 = _k === void 0 ? unmatched : _k, _l = _a[9], tenf_2 = _l === void 0 ? unmatched : _l;
                match2 = function (a, b) {
                    if (one(a)) {
                        return onef_2(a, b);
                    }
                    if (two(a)) {
                        return twof_2(a, b);
                    }
                    if (three(a)) {
                        return threef_2(a, b);
                    }
                    if (four(a)) {
                        return fourf_2(a, b);
                    }
                    if (five(a)) {
                        return fivef_2(a, b);
                    }
                    if (six(a)) {
                        return sixf_2(a, b);
                    }
                    if (seven(a)) {
                        return sevenf_2(a, b);
                    }
                    if (eight(a)) {
                        return eightf_2(a, b);
                    }
                    if (nine(a)) {
                        return ninef_2(a, b);
                    }
                    if (ten(a)) {
                        return tenf_2(a, b);
                    }
                    unmatched(a);
                };
            }
            else {
                match2 = function (a, b) { return p[typeOf(a)](a, b); };
            }
            return spreadInto(match2, p);
        },
        f3: function (p) {
            var match3;
            if (unroll) {
                var _a = keys.map(function (k) { return p[k]; }), _b = _a[0], onef_3 = _b === void 0 ? unmatched : _b, _c = _a[1], twof_3 = _c === void 0 ? unmatched : _c, _d = _a[2], threef_3 = _d === void 0 ? unmatched : _d, _e = _a[3], fourf_3 = _e === void 0 ? unmatched : _e, _f = _a[4], fivef_3 = _f === void 0 ? unmatched : _f, _g = _a[5], sixf_3 = _g === void 0 ? unmatched : _g, _h = _a[6], sevenf_3 = _h === void 0 ? unmatched : _h, _j = _a[7], eightf_3 = _j === void 0 ? unmatched : _j, _k = _a[8], ninef_3 = _k === void 0 ? unmatched : _k, _l = _a[9], tenf_3 = _l === void 0 ? unmatched : _l;
                match3 = function (a, b, c) {
                    if (one(a)) {
                        return onef_3(a, b, c);
                    }
                    if (two(a)) {
                        return twof_3(a, b, c);
                    }
                    if (three(a)) {
                        return threef_3(a, b, c);
                    }
                    if (four(a)) {
                        return fourf_3(a, b, c);
                    }
                    if (five(a)) {
                        return fivef_3(a, b, c);
                    }
                    if (six(a)) {
                        return sixf_3(a, b, c);
                    }
                    if (seven(a)) {
                        return sevenf_3(a, b, c);
                    }
                    if (eight(a)) {
                        return eightf_3(a, b, c);
                    }
                    if (nine(a)) {
                        return ninef_3(a, b, c);
                    }
                    if (ten(a)) {
                        return tenf_3(a, b, c);
                    }
                    unmatched(a);
                };
            }
            else {
                match3 = function (a, b, c) { return p[typeOf(a)](a, b, c); };
            }
            return spreadInto(match3, p);
        },
        f4: function (p) {
            var match4;
            if (unroll) {
                var _a = keys.map(function (k) { return p[k]; }), _b = _a[0], onef_4 = _b === void 0 ? unmatched : _b, _c = _a[1], twof_4 = _c === void 0 ? unmatched : _c, _d = _a[2], threef_4 = _d === void 0 ? unmatched : _d, _e = _a[3], fourf_4 = _e === void 0 ? unmatched : _e, _f = _a[4], fivef_4 = _f === void 0 ? unmatched : _f, _g = _a[5], sixf_4 = _g === void 0 ? unmatched : _g, _h = _a[6], sevenf_4 = _h === void 0 ? unmatched : _h, _j = _a[7], eightf_4 = _j === void 0 ? unmatched : _j, _k = _a[8], ninef_4 = _k === void 0 ? unmatched : _k, _l = _a[9], tenf_4 = _l === void 0 ? unmatched : _l;
                match4 = function (a, b, c, d) {
                    if (one(a)) {
                        return onef_4(a, b, c, d);
                    }
                    if (two(a)) {
                        return twof_4(a, b, c, d);
                    }
                    if (three(a)) {
                        return threef_4(a, b, c, d);
                    }
                    if (four(a)) {
                        return fourf_4(a, b, c, d);
                    }
                    if (five(a)) {
                        return fivef_4(a, b, c, d);
                    }
                    if (six(a)) {
                        return sixf_4(a, b, c, d);
                    }
                    if (seven(a)) {
                        return sevenf_4(a, b, c, d);
                    }
                    if (eight(a)) {
                        return eightf_4(a, b, c, d);
                    }
                    if (nine(a)) {
                        return ninef_4(a, b, c, d);
                    }
                    if (ten(a)) {
                        return tenf_4(a, b, c, d);
                    }
                    unmatched(a);
                };
            }
            else {
                match4 = function (a, b, c, d) { return p[typeOf(a)](a, b, c, d); };
            }
            return spreadInto(match4, p);
        },
        f5: function (p) {
            var match5;
            if (unroll) {
                var _a = keys.map(function (k) { return p[k]; }), _b = _a[0], onef_5 = _b === void 0 ? unmatched : _b, _c = _a[1], twof_5 = _c === void 0 ? unmatched : _c, _d = _a[2], threef_5 = _d === void 0 ? unmatched : _d, _e = _a[3], fourf_5 = _e === void 0 ? unmatched : _e, _f = _a[4], fivef_5 = _f === void 0 ? unmatched : _f, _g = _a[5], sixf_5 = _g === void 0 ? unmatched : _g, _h = _a[6], sevenf_5 = _h === void 0 ? unmatched : _h, _j = _a[7], eightf_5 = _j === void 0 ? unmatched : _j, _k = _a[8], ninef_5 = _k === void 0 ? unmatched : _k, _l = _a[9], tenf_5 = _l === void 0 ? unmatched : _l;
                match5 = function (a, b, c, d, e) {
                    if (one(a)) {
                        return onef_5(a, b, c, d, e);
                    }
                    if (two(a)) {
                        return twof_5(a, b, c, d, e);
                    }
                    if (three(a)) {
                        return threef_5(a, b, c, d, e);
                    }
                    if (four(a)) {
                        return fourf_5(a, b, c, d, e);
                    }
                    if (five(a)) {
                        return fivef_5(a, b, c, d, e);
                    }
                    if (six(a)) {
                        return sixf_5(a, b, c, d, e);
                    }
                    if (seven(a)) {
                        return sevenf_5(a, b, c, d, e);
                    }
                    if (eight(a)) {
                        return eightf_5(a, b, c, d, e);
                    }
                    if (nine(a)) {
                        return ninef_5(a, b, c, d, e);
                    }
                    if (ten(a)) {
                        return tenf_5(a, b, c, d, e);
                    }
                    unmatched(a);
                };
            }
            else {
                match5 = function (a, b, c, d, e) { return p[typeOf(a)](a, b, c, d, e); };
            }
            return spreadInto(match5, p);
        }
    };
    var summation = functions;
    summation.extend = extend(summation);
    return summation;
};
var spreadInto = function (into, from) {
    var keys = Object.keys(from);
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        into[key] = from[key];
    }
    return into;
};
var extend = function (prev) {
    return function (extension) {
        var next = __assign(__assign({}, prev), extension(prev));
        next.extend = extend(next);
        return next;
    };
};
//# sourceMappingURL=sum.js.map